"use client";

import React from 'react';
import { cn } from '@/lib/utils';

export interface DropdownMenuToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  className?: string;
}

export function DropdownMenuToggle({
  checked,
  onChange,
  disabled = false,
  className,
}: DropdownMenuToggleProps) {
  const handleToggle = (e: React.MouseEvent | React.KeyboardEvent) => {
    if (disabled) return;
    e.stopPropagation(); // Prevent triggering parent click handlers (e.g. DropdownMenuItem)
    onChange(!checked);
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handleToggle(e);
    }
  };

  return (
    <div
      role="switch"
      aria-checked={checked}
      tabIndex={disabled ? -1 : 0}
      onClick={handleToggle}
      onKeyDown={handleKeyDown}
      className={cn(
        "relative inline-flex h-[19px] w-[34px] items-center rounded-full transition-colors flex-shrink-0 outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-1",
        checked ? "bg-blue-500" : "bg-gray-300 dark:bg-gray-600",
        disabled && "opacity-50 cursor-not-allowed",
        !disabled && "cursor-pointer",
        className
      )}
    >
      <span
        className={cn(
          "inline-block h-3.5 w-3.5 transform rounded-full bg-white transition-transform",
          checked ? "translate-x-[17.5px]" : "translate-x-[2.5px]"
        )}
      />
    </div>
  );
}

